import React from "react";
import { CgClose } from "react-icons/cg";
import { ImageSlider } from "./ImageSlider";

const DisplayImageSlider = ({ images, onClose }) => {
  return (
    <div className="overlay">
      <style jsx>{`
        .overlay {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 10000;
        }

        .image-modal {
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          border-radius: 8px;
          margin: auto;
          padding: 16px;
          position: relative;
          width: 50vw;
          height: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-icon {
          position: absolute;
          top: 8px;
          right: 8px;
          cursor: pointer;
          color: #ff6b6b;
          transition: color 0.3s ease;
        }

        .close-icon:hover {
          color: #ff4c4c;
        }

        .image-container {
          display: flex;
          justify-content: center;
          padding: 16px;
          max-width: 80vh;
          max-height: 80vh;
          overflow: hidden;
        }

        .full-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @media screen and (max-width: 678px) {
          .image-modal {
            width: 90vw;
          }
          .image-container {
            width: 100vh;
            box-shadow: none;
          }
          .close-icon {
            top: 2px;
            right: -5px;
          }
        }
      `}</style>
      <div className="image-modal">
        <div className="close-icon" onClick={onClose}>
          <CgClose style={{ fontSize: "40px" }}/>
        </div>
        <div className="image-container">
          <ImageSlider data={images} /> {/* Pass all images to ImageSlider */}
        </div>
      </div>
    </div>
  );
};

export default DisplayImageSlider;

// import React from "react";
// import { CgClose } from "react-icons/cg";
// import { ImageSlider } from "./ImageSlider";
// import styles from '../css/DisplayImagesSliders.css'; // Import the CSS module

// const DisplayImageSlider = ({ images, onClose }) => {
//   return (
//     <div className={styles.overlaySlider}>
//       <div className={styles.imageModalSlider}>
//         <div className={styles.closeIconSlider} onClick={onClose}>
//           <CgClose style={{ fontSize: "40px", borderRadius: "50%" }} />
//         </div>
//         <div className={styles.imageContainerSlider}>
//           <ImageSlider data={images} /> {/* Pass all images to ImageSlider */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DisplayImageSlider;
